import React, { useRef, useEffect } from "react";
import Link from "next/link";
import CarouselItemSmallScreen from "components/Items/SmallScreenItems/carouselItemSmallScreens";
import ChurchCarouselItemSmallScreen from "components/Items/SmallScreenItems/churchCarouselItemSmallScreens";
import ArrowLeft from "../Icons/ArrowLeft";
import ArrowRight from "../Icons/ArrowRight";

const Carousel = ({
  header,
  data,
  isLive = false,
  link,
  upcomingEvent = false,
  isChurch = false,
}) => {
  const scrollRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  const checkButtons = () => {
    if (rightRef?.current?.disabled) {
      rightRef?.current?.removeAttribute("disabled");
    }
    if (leftRef?.current?.disabled) {
      leftRef?.current?.removeAttribute("disabled");
    }

    if (
      scrollRef?.current?.clientWidth + scrollRef?.current?.scrollLeft ===
      scrollRef?.current?.scrollWidth
    ) {
      rightRef?.current?.setAttribute("disabled", true);
    } else if (scrollRef?.current?.scrollLeft === 0) {
      leftRef?.current?.setAttribute("disabled", true);
    }
  };

  useEffect(() => {
    if (scrollRef?.current) {
      leftRef?.current?.setAttribute("disabled", true);
      scrollRef.current.addEventListener("scroll", checkButtons, false);
    }
    return () => {
      scrollRef?.current?.removeEventListener("scroll", checkButtons);
    };
  }, []);

  return (
    <section className="w-full hidden tablet-100:block">
      <header className="flex items-center">
        <h2
          className={`text-2xl font-bold pl-14 flex items-center pl-6 phone:pl-4 phone-100:text-bodyText phone:text-lg ${
            isLive ? "pr-12" : ""
          }`}
        >
          {header}{" "}
        </h2>
        {isLive && (
          <>
            {" "}
            <div className="bg-red rounded-full max-w-redDot w-full h-16 ml-2"></div>
          </>
        )}
        <div className="flex items-center ml-4">
          <button
            onClick={() =>
              scrollRef?.current?.scroll({
                top: 0,
                left: scrollRef?.current?.scrollLeft - 506,
                behavior: "smooth",
              })
            }
            ref={leftRef}
            className="w-6 h-[24px] flex items-center justify-center bg-blue rounded-full disabled:opacity-50"
          >
            <ArrowLeft height={10} width={10} />
          </button>
          <button
            onClick={() =>
              scrollRef?.current?.scroll({
                top: 0,
                left: scrollRef?.current?.scrollLeft + 506,
                behavior: "smooth",
              })
            }
            ref={rightRef}
            className="ml-2 w-6 h-[24px] flex items-center justify-center bg-blue rounded-full disabled:opacity-50"
          >
            <ArrowRight height={10} width={10} />
          </button>
        </div>
      </header>
      <div
        className="no-scrollbar flex relative overflow-y-visible overflow-scroll"
        ref={scrollRef}
      >
        <div className="flex py-8">
          <ul className="flex">
            {data.map((itemData, i) =>
              isChurch ? (
                <div
                  className="flex first:pl-14 phone:first:pl-4"
                  key={itemData?._id}
                >
                  <ChurchCarouselItemSmallScreen
                    idx={i}
                    position={i}
                    itemData={itemData}
                  />
                </div>
              ) : (
                <div
                  className="flex first:pl-14 phone:first:pl-4"
                  key={itemData?._id}
                >
                  <CarouselItemSmallScreen
                    upcomingEvent={upcomingEvent}
                    position={i}
                    itemData={itemData}
                    isLive={isLive}
                  />
                </div>
              )
            )}
            {link && (
              <li className="block pr-14">
                <Link href={`/${link}`}>
                  <a>
                    <div
                      className={`mx-1 group rounded-lg w-full transition-all duration-200 ease-linear delay ${
                        isChurch ? "min-w-[240px]" : "min-w-[245px]"
                      } `}
                    >
                      <div
                        className={` rounded-10  max-w-full w-full ${
                          isChurch ? " h-[368px]" : "h-[179px]"
                        } object-cover object-bottom t bg-center bg-defaultTabletCarousel`}
                      >
                        <div
                          className={`rounded-10  max-w-full w-full object-cover object-bottom transition-all duration-200 ease-linear delay bg-blue-100 ${
                            isChurch ? " h-[368px]" : "h-[179px]"
                          }`}
                        />
                        <article className="rounded-br-lg rounded-bl-lg bg-white-100 transition-all duration-200 ease-linear delay flex items-center pr-1">
                          <div className="flex flex-col w-full">
                            <h2 className="py-1.5 font-bold text-left bg-white-100 transition duration-200 flex items-center justify-between text-blue-100">
                              <div className="text-bodyText origin-left tablet-100:text-[17px] leading-[25px]">
                                Katso kaikki
                              </div>
                            </h2>
                          </div>
                        </article>
                      </div>
                    </div>
                  </a>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Carousel;
